module.exports = __webpack_public_path__ + "static/media/22.57e3dda0.jpg";